export default "__VITE_PUBLIC_ASSET__777325b9__"